import { makeStyles } from '@mui/styles'
import { makeSx } from '@saas/lib/shared-utils'
import { defaultPalette } from '../../../theme/idsTheme'

export const datePickerSx = makeSx({
    datePickerContainer: {
        width: '100%',
        flexDirection: 'row',
        background: defaultPalette.white.main,
        borderRadius: '1rem',
        border: `1px solid ${defaultPalette.lightGrey.mediumDark}`,
        padding: '2.125rem',
        boxShadow: '0 3px 20px 0 rgba(122, 125, 171, 0.06)',
        transition: 'border-color 0.2s ease, border-radius 0.2s ease',
        boxSizing: 'border-box',

        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${defaultPalette.lightGrey.mediumDark} !important`,
            outline: 'none !important',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: `${defaultPalette.expertise.main} !important`,
            borderWidth: '2px !important',
        },
        '& .MuiOutlinedInput-root.Mui-focused': {
            outline: 'none !important',
        },
        '& input:focus': {
            outline: 'none !important',
        },
        '& .MuiSvgIcon-root': {
            color: `${defaultPalette.expertise.main} !important`,
        },
        '& .MuiIconButton-root': {
            color: `${defaultPalette.expertise.main} !important`,
        },
        '& .MuiIconButton-root:hover': {
            backgroundColor: 'rgba(87, 91, 175, 0.08) !important',
        },
        '& .MuiPickersYear-yearButton.Mui-selected': {
            backgroundColor: `${defaultPalette.expertise.main} !important`,
            color: `${defaultPalette.white.main} !important`,
        },
        '& .MuiPickersYear-yearButton:hover': {
            backgroundColor: `${defaultPalette.lightGrey.superLight} !important`,
        },
        '& .MuiPickersToolbarText-root.Mui-selected': {
            color: `${defaultPalette.expertise.main} !important`,
        },
        '& .MuiPickersCalendarHeader-switchViewButton': {
            color: `${defaultPalette.expertise.main} !important`,
        },
        '& .MuiPickersCalendarHeader-label': {
            color: defaultPalette.expertise.stale,
        },
    },
    dateLabelContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: '0.5rem',
        marginBottom: '0.5rem',
    },
    dateLabel: {
        fontSize: '1rem',
        fontWeight: 600,
        transition: 'color 0.2s ease',
        cursor: 'pointer',
    },
    dateLabelActive: {
        color: defaultPalette.expertise.main,
    },
    dateLabelInactive: {
        color: defaultPalette.expertise.stale,
    },
    dateLabelError: {
        color: defaultPalette.error.main,
    },
    dateIconActive: {
        width: '1.125rem',
        height: '1.125rem',
        fill: defaultPalette.expertise.main,
    },
    popper: {
        '& .MuiPickersDay-root.Mui-selected': {
            backgroundColor: `${defaultPalette.expertise.main} !important`,
            color: `${defaultPalette.white.main} !important`,
            '&:hover': {
                backgroundColor: `${defaultPalette.expertise.accent} !important`,
            },
        },
        '& .MuiPickersDay-root.MuiPickersDay-today': {
            transition: 'none !important',
            backgroundColor: 'transparent !important',
            border: `1px solid ${defaultPalette.expertise.main} !important`,
        },
        '& .MuiPickersDay-root:hover': {
            backgroundColor: defaultPalette.lightGrey.superLight,
        },
        '& .MuiPickersYear-yearButton.Mui-selected': {
            backgroundColor: `${defaultPalette.expertise.main} !important`,
            color: `${defaultPalette.white.main} !important`,
        },
        '& .MuiPickersMonth-monthButton.Mui-selected': {
            backgroundColor: `${defaultPalette.expertise.main} !important`,
            color: `${defaultPalette.white.main} !important`,
        },
        '& .MuiDialogActions-root .MuiButton-root': {
            color: `${defaultPalette.expertise.main}`,
        },
        '& .MuiPickersToolbar-root': {
            backgroundColor: defaultPalette.lightGrey.superLighter,
        },
    },
    datePickerContainerError: {
        borderColor: defaultPalette.error.main,
        borderRadius: '1rem 1rem 0 0',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${defaultPalette.error.main} !important`,
        },
    },
    errorMessageContainer: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
        marginTop: 0,
        padding: '0.75rem 2.125rem',
        color: defaultPalette.error.main,
        backgroundColor: defaultPalette.error.light,
        borderRadius: '0 0 1rem 1rem',
        border: `1px solid ${defaultPalette.error.main}`,
        borderTop: 'none',
        boxSizing: 'border-box',
    },
    errorIcon: {
        fill: defaultPalette.error.main,
    },
})

export const sketcherSx = makeSx({
    sketchArea: {
        position: 'relative',
        height: '17.688rem',
        marginY: '0.5rem',
        borderRadius: '0.75rem',
        background: defaultPalette.lightGrey.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    sketchLockWrapper: {
        position: 'relative',
    },
    sketchLockOverlay: {
        position: 'absolute',
        inset: 0,
        marginY: '0.5rem',
        borderRadius: '0.75rem',
        background: 'rgba(255, 255, 255, 0.6)',
        cursor: 'not-allowed',
    },
    sketchCard: {
        background: defaultPalette.white.main,
        borderRadius: '1rem',
        padding: '1.5rem',
        border: `2px solid ${defaultPalette.lightGrey.mediumDark}`,
    },
    toolbarRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '1.5rem',
        justifyContent: 'flex-start',
    },
    buttonGroup: {
        display: 'flex',
        gap: '1.25rem',
        alignItems: 'center',
    },
    verticalDivider: {
        width: '1px',
        height: 'auto',
        background: defaultPalette.lightGrey.mediumDark,
    },
    horizontalDivider: {
        marginY: '1rem',
        borderColor: defaultPalette.lightGrey.mediumDark,
    },
    resetButton: {
        padding: 0,
        flexShrink: 0,
        color: defaultPalette.typography.main,
        fontWeight: 600,
        '& svg': {
            display: 'inline-block',
            width: '1.5rem',
            height: '1.5rem',
        },
        '& svg path': {
            fill: defaultPalette.typography.main,
        },
        '&.Mui-disabled': {
            color: `${defaultPalette.lightGrey.muted}`,
            '& svg path': {
                fill: `${defaultPalette.lightGrey.muted}`,
            },
        },
        '&:hover': {
            background: 'transparent',
        },
    },
})

export const numberFreeQuestionSx = makeSx({
    numberInput: {
        width: '100%',
        '& .MuiInputBase-root': {
            height: '5.625rem',
            borderRadius: '1rem',
            border: `2px solid ${defaultPalette.lightGrey.mediumDark}`,
            background: defaultPalette.white.main,
            boxShadow: '0 2px 12px 0 rgba(182, 184, 202, 0.12)',
            padding: '0 2.125rem',
            transition: 'all 0.2s ease',
            outline: 'none',
            '&.Mui-focused': {
                borderColor: defaultPalette.expertise.main,
                boxShadow: '0 2px 12px 0 rgba(87, 91, 175, 0.2)',
                outline: 'none',
            },
        },
        '& .MuiInputBase-input': {
            padding: '2.125rem 0',
            fontSize: '1.125rem',
            fontWeight: 500,
            color: defaultPalette.expertise.stale,
            outline: 'none',
            '&:focus': {
                outline: 'none',
            },
            '&::placeholder': {
                color: defaultPalette.lightGrey.slate,
                opacity: 1,
                fontSize: '1rem',
                fontWeight: 400,
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .MuiSvgIcon-root': {
            color: defaultPalette.expertise.main,
        },
        '& .MuiIconButton-root': {
            color: defaultPalette.expertise.main,
            '&:hover': {
                backgroundColor: 'rgba(87, 91, 175, 0.08)',
            },
        },
    },
    numberInputError: {
        '& .MuiInputBase-root': {
            borderBottom: 'none',
            borderColor: defaultPalette.error.main,
            borderRadius: '1rem 1rem 0 0',
            boxShadow: 'none !important',
            '&.Mui-focused': {
                borderColor: defaultPalette.error.main,
            },
        },
    },
})

export const textFreeQuestionSx = makeSx({
    editor: {
        width: '100%',
        maxWidth: '40rem',
        maxHeight: '40rem',
        background: defaultPalette.white.main,
        border: `2px solid ${defaultPalette.lightGrey.mediumDark}`,
        borderRadius: '1rem',
        overflow: 'hidden',
        paddingTop: 0,
        boxShadow: '0 2px 12px 0 rgba(182, 184, 202, 0.12)',
        display: 'flex',
        flexDirection: 'column',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '3.563rem',
        paddingTop: '1.5rem',
        backgroundColor: defaultPalette.white.main,
        flexShrink: 0,
    },
    textarea: {
        fontSize: '1.125rem',
        fontFamily: 'AvertaPE-Semibold',
        color: '#2F3135',
        flex: '0 1 auto',
        minHeight: 0,
        overflow: 'hidden',
        alignItems: 'flex-start',
        paddingTop: '1rem',
        '& textarea': {
            resize: 'none',
            whiteSpace: 'pre-wrap',
            overflowY: 'auto !important',
        },
        '& textarea::placeholder': {
            color: defaultPalette.lightGrey.slate,
            opacity: 1,
            fontSize: '1.125rem',
            fontWeight: 500,
        },
    },
    customDivider: {
        borderColor: `${defaultPalette.lightGrey.mediumDark} !important`,
        flexShrink: 0,
    },
    textFreeQuestionError: {
        borderColor: defaultPalette.error.main,
    },
    textFreeQuestionErrorMessage: {
        width: '100%',
        padding: '0.75rem 2.125rem',
        marginLeft: 0,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
        backgroundColor: defaultPalette.error.light,
        color: defaultPalette.error.main,
    },
    errorIcon: {
        fill: defaultPalette.error.main,
    },
})

export const sliderSx = makeSx({
    transmissionSliderContainer: {
        width: {
            xs: 'auto',
            lg: '100%',
        },
        background: '#FFF',
        borderRadius: '16px',
        gap: '10px',
        padding: '50px 34px 34px 34px',
        boxShadow: '0 2px 12px rgba(182, 184, 202, 0.12)',
        border: '1px solid #E5E9F2',
    },
    slider: {
        '& .MuiSlider-rail': {
            opacity: 1,
            backgroundColor: '#D9D9F5',
        },
        '& .MuiSlider-track': {
            border: 'none',
            backgroundColor: '#575BAF',
        },
        '& .MuiSlider-thumb': {
            width: 22,
            height: 22,
            backgroundColor: '#5B57D6',
            boxShadow: '0 2px 6px rgba(91, 87, 214, 0.4)',
            '&:hover, &.Mui-focusVisible': {
                boxShadow: '0 0 0 8px rgba(91, 87, 214, 0.16)',
            },
            '&.Mui-active': {
                boxShadow: '0 0 0 12px rgba(91, 87, 214, 0.2)',
            },
        },
        '& .MuiSlider-mark': {
            width: 8,
            height: 8,
            borderRadius: '100px',
            backgroundColor: '#B9B9EA',
        },
        '& .MuiSlider-markActive': {
            backgroundColor: '#B9B9EA',
            opacity: 1,
        },
        '& .MuiSlider-valueLabel': {
            backgroundColor: '#313336',
            borderRadius: '8px',
            fontSize: '18px',
            fontWeight: 600,
            padding: '8px 12px',
            top: -6,
            '&:before': {
                display: 'block',
            },
        },
    },
    sliderValueContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    sliderValueLabel: {
        marginTop: '-4px',
        fontSize: '18px',
    },
})

export default makeStyles((theme) => ({
    section: {
        width: '100%',
        maxWidth: '736px',
        margin: '0 auto',
        padding: 0,
    },
    questionWrapper: {
        width: '100%',
        maxWidth: '595px',
        margin: '0 auto',
        padding: '8px 16px 24px',
    },
    questionHeader: {
        marginBottom: '24px',
    },
    questionSectionLabel: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#575BAF',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '8px',
    },
    questionTitle: {
        fontSize: '20px',
        fontWeight: 700,
        color: '#1A1B1E',
        lineHeight: '28px',
        marginBottom: '8px',
    },
    questionHint: {
        fontSize: '14px',
        fontWeight: 400,
        color: '#6B6F76',
        lineHeight: '20px',
    },
    choicesContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '16px',
        width: '100%',
        paddingBottom: '1rem',
        '@media (max-width: 768px)': {
            gridTemplateColumns: '1fr',
        },
    },
    choiceButton: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        minWidth: '312px',
        minHeight: '60px',
        padding: '26px 24px',
        borderRadius: '14px',
        border: '1px solid #E5E9F2',
        background: '#FFF',
        boxShadow: '0 2px 12px rgba(182, 184, 202, 0.12)',
        cursor: 'pointer',
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 600,
        color: '#313336',
        transition: 'all .2s ease',
        '&:hover': {
            background: '#F5F5FF',
            borderColor: '#D5D8F7',
        },
        '&.selected': {
            border: '2px solid #555ABE',
            background: '#F6F6FE',
        },
    },
    checkIcon: {
        color: '#575BAF',
        fontSize: '22px',
        flex: '0 0 auto',
    },
    textFreeButtons: {
        display: 'flex',
        gap: '12px',
        marginTop: '16px',
    },
    numberField: {
        width: '100%',
        height: '94px',
        padding: '34px',
        gap: '16px',
        borderRadius: '16px',
        border: '2px solid #E5E9F2',
        background: '#FFF',
        boxShadow: '0 2px 12px 0 rgba(182, 184, 202, 0.12)',
    },
    toolbarButton: {
        textTransform: 'none',
        color: defaultPalette.typography.main,
        fontSize: 16,
        fontWeight: 600,
        minWidth: 'unset',
        '& .MuiSvgIcon-root': {
            width: '24px',
            height: '24px',
        },
        '&:hover': {
            background: 'transparent',
        },
        '&.Mui-disabled': {
            color: '#C8CBD5',
        },
    },
    dateIcon: {
        transition: 'fill 0.2s ease',
    },

    dateIconInactive: {
        fill: '#1A1B1E',
    },
    container: {
        maxWidth: 640,
        margin: '0 auto',
    },
    toolbarDividerVertical: {
        borderColor: '#E5E9F2',
        height: '20px',
    },
    toolbarDividerHorizontal: {
        borderColor: '#E5E9F2',
        marginTop: '12px',
    },
    actionButton: {
        border: 'none',
        color: defaultPalette.typography.main,
        padding: 0,
        minWidth: 'unset',
        borderRadius: 0,
        fontWeight: 600,
        '&.MuiButton-outlined': {
            border: 'none !important',
            '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                margin: 0,
            },
        },
        '& svg': {
            width: '1.5rem',
            height: '1.5rem',
        },
        '& svg path': {
            fill: defaultPalette.typography.main,
        },
        '&:hover': {
            background: 'transparent',
            border: 'none !important',
        },
        '&.Mui-disabled': {
            border: 'none !important',
            background: 'transparent !important',
            color: '#C8CBD5 !important',
            cursor: 'not-allowed',
            '& svg path': {
                fill: '#C8CBD5 !important',
            },
            '&:hover': {
                background: 'transparent !important',
                border: 'none !important',
            },
        },
    },

    sketchPlaceholder: {
        color: '#6B6F76',
        fontFamily: 'AvertaPE-SemiBold',
    },
    customDividerVertical: {
        width: '1px',
        height: '20px',
        backgroundColor: '#E5E9F2',
        flexShrink: 0,
        marginLeft: '24px',
        marginRight: '24px',
    },
    customDividerHorizontal: {
        width: '100%',
        height: '1px',
        backgroundColor: '#E5E9F2',
        marginTop: '12px',
    },
    autoCalculatedContainer: {
        padding: '26px 24px',
        borderRadius: '16px',
        backgroundColor: '#F6F6FE',
        border: '2px solid rgba(87, 91, 175, 0.58)',
        boxShadow: '0 2px 12px 0 rgba(182, 184, 202, 0.12)',
    },
    autoCalculatedContent: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    autoCalculatedText: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    autoCalculatedValue: {
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '16px',
        lineHeight: '24px',
        color: '#313336',
    },
    autoCalculatedSubtitle: {
        fontFamily: 'AvertaPE-Regular',
        fontSize: '14px',
        lineHeight: '22px',
        color: '#313336',
        fontWeight: 400,
    },
    autoCalculatedLockIcon: {
        fontSize: 20,
        color: '#787AAB',
    },
}))
